import { Button } from 'antd'
import * as React from 'react'

import { NewItemButtonProps } from '../dtos'

import * as styles from './NewItemButton.module.less'

export const NewItemButtonDefault: React.FC<NewItemButtonProps> = (props) => {
    const { onNewItemClicked, position } = props
    const isDisabled = props.isDisabled !== undefined ? props.isDisabled : false
    const title = props.title || '+'

    return (
        <div className={styles.newItemButton}>
            <Button
                block
                size="small"
                type="primary"
                disabled={isDisabled}
                onClick={() => onNewItemClicked && onNewItemClicked(position)}
            >
                <span style={{ fontSize: '1.6rem', lineHeight: '1rem' }}>
                    {title}
                </span>
            </Button>
        </div>
    )
}
